import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBed"><Path d="M4 4H11.25V9.5H4V4Z" fill="currentColor"/><Path d="M12.75 9.5V4H20V9.5H12.75Z" fill="currentColor"/><Path d="M22 11H2V18H4V20H5.5V18H18.5V20H20V18H22V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBed;
